import axios from 'axios';

const instance = axios.create({ 
    baseURL: process.env.REACT_APP_URL_BASE,
    headers: { "X-Api-Key" : process.env.REACT_APP_API_KEY }
});

const request = {
    get: (url) => instance.get(url),
    post: (url, body) => instance.post(url, body),
    put: (url, body) => instance.put(url, body),
    delete: (url) => instance.delete(url)
}

export default request;